import { unsafeCSSVar } from '@blocksuite/hive-shared/theme';
import { baseTheme } from '@toeverything/theme';
import { css, unsafeCSS } from 'lit';

export const styles = css`
  bookmark-card {
    display: block;
    height: 100%;
    width: 100%;
  }

  .hive-bookmark-card {
    container: hive-bookmark-card / inline-size;
    margin: 0 auto;
    box-sizing: border-box;
    display: flex;
    width: 100%;

    border-radius: 8px;
    border: 1px solid var(--hive-background-tertiary-color);

    opacity: var(--add, 1);
    background: var(--hive-background-primary-color);
    user-select: none;
  }

  .hive-bookmark-content {
    width: calc(100% - 204px);
    display: flex;
    flex-direction: column;
    align-self: stretch;
    gap: 4px;
    padding: 12px;
    border-radius: var(--1, 0px);
    opacity: var(--add, 1);
  }

  .hive-bookmark-content-title {
    display: flex;
    flex-direction: row;
    gap: 8px;
    align-items: center;

    align-self: stretch;
    padding: var(--1, 0px);
    border-radius: var(--1, 0px);
    opacity: var(--add, 1);
  }

  .hive-bookmark-content-title-icon {
    display: flex;
    width: 16px;
    height: 16px;
    justify-content: center;
    align-items: center;
  }

  .hive-bookmark-content-title-icon img,
  .hive-bookmark-content-title-icon object,
  .hive-bookmark-content-title-icon svg {
    width: 16px;
    height: 16px;
    fill: var(--hive-background-primary-color);
  }

  .hive-bookmark-content-title-text {
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;

    word-break: break-word;
    overflow: hidden;
    text-overflow: ellipsis;
    color: var(--hive-text-primary-color);

    font-family: var(--hive-font-family);
    font-size: var(--hive-font-sm);
    font-style: normal;
    font-weight: 600;
    line-height: 22px;
  }

  .hive-bookmark-content-description {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;

    flex-grow: 1;

    white-space: normal;
    word-break: break-word;
    overflow: hidden;
    text-overflow: ellipsis;
    color: var(--hive-text-primary-color);

    font-family: var(--hive-font-family);
    font-size: var(--hive-font-xs);
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
  }

  .hive-bookmark-content-url {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 4px;
    width: max-content;
    max-width: 100%;
  }

  .hive-bookmark-content-url > span {
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;

    word-break: break-all;
    white-space: normal;
    overflow: hidden;
    text-overflow: ellipsis;
    color: var(--hive-text-secondary-color);

    font-family: ${unsafeCSS(baseTheme.fontSansFamily)};
    font-size: var(--hive-font-xs);
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
  }
  .hive-bookmark-content-url:hover > span {
    color: var(--hive-link-color);
  }
  .hive-bookmark-content-url:hover {
    fill: var(--hive-link-color);
  }

  .hive-bookmark-content-url-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 12px;
    height: 20px;
  }
  .hive-bookmark-content-url-icon {
    height: 12px;
    width: 12px;
    color: ${unsafeCSSVar('iconSecondary')};
  }

  .hive-bookmark-banner {
    margin: 12px 12px 0px 0px;
    width: 204px;
    max-width: 100%;
    height: 102px;
    opacity: var(--add, 1);
  }

  .hive-bookmark-banner img,
  .hive-bookmark-banner object,
  .hive-bookmark-banner svg {
    width: 204px;
    max-width: 100%;
    height: 102px;
    object-fit: cover;
    border-radius: 4px 4px var(--1, 0px) var(--1, 0px);
  }

  .hive-bookmark-card.loading {
    .hive-bookmark-content-title-text {
      color: var(--hive-placeholder-color);
    }
  }

  .hive-bookmark-card.error {
    .hive-bookmark-content-description {
      color: var(--hive-placeholder-color);
    }
  }

  .hive-bookmark-card.selected {
    .hive-bookmark-content-url > span {
      color: var(--hive-link-color);
    }
    .hive-bookmark-content-url .hive-bookmark-content-url-icon {
      color: var(--hive-link-color);
    }
  }

  .hive-bookmark-card.list {
    .hive-bookmark-content {
      width: 100%;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
    }

    .hive-bookmark-content-title {
      width: calc(100% - 204px);
    }

    .hive-bookmark-content-url {
      width: 204px;
      justify-content: flex-end;
    }

    .hive-bookmark-content-description {
      display: none;
    }

    .hive-bookmark-banner {
      display: none;
    }
  }

  .hive-bookmark-card.vertical {
    flex-direction: column-reverse;
    height: 100%;

    .hive-bookmark-content {
      width: 100%;
    }

    .hive-bookmark-content-description {
      -webkit-line-clamp: 6;
      max-height: 120px;
    }

    .hive-bookmark-content-url-wrapper {
      max-width: fit-content;
      display: flex;
      align-items: flex-end;
      flex-grow: 1;
      cursor: pointer;
    }

    .hive-bookmark-banner {
      width: 340px;
      height: 170px;
      margin-left: 12px;
    }

    .hive-bookmark-banner img,
    .hive-bookmark-banner object,
    .hive-bookmark-banner svg {
      width: 340px;
      height: 170px;
    }
  }

  .hive-bookmark-card.cube {
    .hive-bookmark-content {
      width: 100%;
      flex-direction: column;
      align-items: flex-start;
      justify-content: space-between;
    }

    .hive-bookmark-content-title {
      flex-direction: column;
      gap: 4px;
      align-items: flex-start;
    }

    .hive-bookmark-content-title-text {
      -webkit-line-clamp: 2;
    }

    .hive-bookmark-content-description {
      display: none;
    }

    .hive-bookmark-banner {
      display: none;
    }
  }

  @container hive-bookmark-card (width < 375px) {
    .hive-bookmark-content {
      width: 100%;
    }
    .hive-bookmark-banner {
      display: none;
    }
  }
`;
